import { render, staticRenderFns } from "./Items.vue?vue&type=template&id=2cb19a8e&scoped=true&"
import script from "./Items.vue?vue&type=script&lang=js&"
export * from "./Items.vue?vue&type=script&lang=js&"
import style0 from "./Items.vue?vue&type=style&index=0&id=2cb19a8e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cb19a8e",
  null
  
)

/* custom blocks */
import block0 from "./Items.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

/* hot reload */
if (module.hot) {
  var api = require("/data/vstsagent/user/4158/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2cb19a8e')) {
      api.createRecord('2cb19a8e', component.options)
    } else {
      api.reload('2cb19a8e', component.options)
    }
    module.hot.accept("./Items.vue?vue&type=template&id=2cb19a8e&scoped=true&", function () {
      api.rerender('2cb19a8e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/steps/Items.vue"
export default component.exports